// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { getText } from '../../../../utils/util'
import { financeApi } from '../../../../api/finance-api'
import { SpinLoading, Dialog } from 'antd-mobile'
import { ArrowLeftOutlined, FieldTimeOutlined, RightOutlined, DownOutlined } from '@ant-design/icons'
import './index.css'
import { useState, useEffect } from 'react'
import { Dropdown } from 'antd'
import { Toast } from 'antd-mobile'
import { companyApi } from '../../../../api/company'

export default function CenterPage({ add, loading }) {
  const uid = localStorage.getItem('uid')
  const navigate = useNavigate()
  const { t: translate } = useTranslation()
  const lan = localStorage.getItem('i18n')
  const [isAggres, setisAggres] = useState(false)
  const [num, setNum] = useState(0)
  const [type, setType] = useState(1)
  const [code, setCode] = useState('code')
  const [invite, setInvite] = useState('')
  const [applicationAmount, setApplicationAmount] = useState(0)
  const [companyData, setCompanyData] = useState({} as any)

  //初始化获取公司
  async function initCompany() {
    const res = await companyApi.domain()
    if (res.ok) {
      setCompanyData(res.data)
    }
  }

  const items = [
    {
      key: '1',
      label: <span>{translate(getText('活期利率'))}</span>
    }
    // {
    //   key: "2",
    //   label: <span>定期利率</span>,
    // },
  ]

  const LoanAgreementContent = ({ name, userId }) => {
    const agreementSections = [
      {
        title: translate(getText('协议签订方')),
        content: [
          translate(getText('本协议由以下各方签订:')),
          `${translate(getText('贷款人'))}：${name}${translate(getText('(本平台)'))}`,
          translate(getText('借款人')) + '：' + translate(getText('(本平台)')) + '-ID' + userId
        ]
      },
      {
        title: translate(getText('一、贷款金额和期限')),
        content: [
          translate(getText('1. 借款人必须同意平台的条款和条件。')),
          translate(getText('2. 放款人同意向借款人提供USDT的贷款金额。')),
          translate(getText('3. 贷款期限为15天、30天或60天，从签署本协议之日起计算。在免息天数内，如果超过免息天数，将按照规定计息。')),
          translate(
            getText('4. 如果借款人未能在贷款期限内偿还全部本金，将按免息日后未偿还本金每天1%的利率计息。如果超过还款天数,将计入违约金。')
          )
        ]
      },
      {
        title: translate(getText('二、贷款目的')),
        content: [translate(getText('借款人同意仅将本协议项下的贷款用于加密货币交易。借款人不得将贷款用于加密货币活动以外的任何用途。'))]
      },
      {
        title: translate(getText('三、贷款条件')),
        content: [
          translate(getText('1. 借款人需要提供贷款交易账户中的加密货币资产作为抵押。')),
          translate(getText('2. 借款人需提供个人身份证件。')),
          translate(getText('3. 借款人必须提供一名近亲的姓名和联系电话。')),
          translate(getText('4. 借款人必须提供个人住址和银行对账单照片。')),
          translate(getText('5. 一旦获得批准,放款人会在30分钟内将贷款转入借款人的加密货币账户。')),
          translate(getText('6. 当借款人要偿还贷款时,必须通过个人外部钱包或交易所软件向指定的支付地址还款。')),
          translate(getText('注：在此期间,您交易账户的所有提现功能都将暂停,直到贷款全部还清,您的提现功能才会恢复。'))
        ]
      },
      {
        title: translate(getText('四、还款方式')),
        content: [
          translate(getText('1. 借款人应在贷款期满后全额偿还本金和利息。')),
          translate(getText('2. 借款人应在到期日之前全额偿还贷款本息。还款应直接支付给本平台。'))
        ]
      },
      {
        title: translate(getText('五、提前还款')),
        content: [translate(getText('借款人可提前偿还贷款,若违约,则必须支付所有适用的利息和滞纳金。'))]
      },
      {
        title: translate(getText('六、保密条款')),
        content: [
          translate(getText('1. 本协议签署后,除非获得另一方的书面同意或法律要求,否则任何一方不得向第三方披露本协议的内容。')),
          translate(getText('2. 但是，如果一方未能遵守协议，给另一方造成损失，则有必要披露协议的相关内容，以保护自己的权益。'))
        ]
      },
      {
        title: translate(getText('七、违约责任')),
        content: [
          translate(getText('1. 借款人未按本协议约定履行还款义务的,应承担违约责任，并按贷款人的要求进行赔偿。')),
          translate(getText('2. 借款人未在约定期限内按时还本付息的,应承担逾期违约责任，并按贷款人要求进行赔偿。'))
        ]
      },
      {
        title: translate(getText('八、违约条款')),
        content: [
          translate(
            getText(
              '1. 因借款人原因导致借款人不能按时履行还款义务的,除按贷款人要求承担违约责任外,还应承担违约责任,并按本协议规定进行赔偿。'
            )
          ),
          translate(getText('2. 因投资失败造成的经济损失由借款人承担,并在规定期限内偿还。')),
          translate(getText('3. 如果拒绝还款,您将收到我们法律团队的信函。')),
          translate(getText('4. (本平台)有权在不事先通知的情况下更改本协议,并保留最终解释权。'))
        ]
      }
    ]

    return (
      <div className="text-neutral-100 max-h-96 overflow-y-auto">
        {agreementSections.map((section, index) => (
          <div key={index} className="mb-4">
            <h3 className="text-primary-light font-medium text-base mb-2">{section.title}</h3>
            <div className="text-neutral-300 text-sm">
              {section.content.map((item, itemIndex) => (
                <p key={itemIndex} className="mb-1">
                  {item}
                </p>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }

  // 在Dialog中使用
  const showLoanAgreement = () => {
    Dialog.show({
      title: translate(getText('借币服务协议')),
      content: <LoanAgreementContent name={companyData.name} userId={localStorage.getItem('userCode')} />,
      closeOnAction: true,
      actions: [
        {
          key: 'confirm',
          text: translate(getText('我已阅读并同意')),
          primary: true,
          onClick: () => {
            setisAggres(true) // 设置同意状态为true
          }
        }
      ]
    })
  }

  function getRandomString(length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  const getCode = () => {
    let randomString = getRandomString(6)
    setCode(randomString)
  }

  const loadData = async () => {
    const data = await financeApi.userCoin({ uid }).then((resp) => {
      // setNum((Number(resp.data.usdt) * 0.8).toFixed(2));
      setApplicationAmount((Number(resp.data.usdt) * Number(localStorage.getItem('pledgeFee'))) / 100)
    })
    // if (data.ok) {

    // }
  }

  useEffect(() => {
    getCode()
    loadData()
    initCompany()
  }, [])

  return (
    <div className="min-h-screen bg-neutral-900 text-neutral-100">
      {/* 主要内容 */}
      <div className="max-w-md mx-auto p-4">
        {/* 借币类型选择 */}
        <div className="mb-6">
          <label className="block text-neutral-400 mb-2 font-medium">
            {translate(getText("借币类型"))}
          </label>
          <Dropdown menu={{ items }}>
            <button className="w-full flex items-center justify-between bg-neutral-800 rounded-lg p-3 border border-neutral-700 focus:outline-none focus:border-primary transition-colors">
              <div className="flex items-center">
                <span className="text-neutral-100">
                  {translate(getText("活期利率"))}
                </span>
                <span className="ml-2 bg-primary bg-opacity-20 text-primary-light text-xs py-0.5 px-2 rounded">
                  {translate(getText("低利率"))}
                </span>
              </div>
              <DownOutlined className="text-neutral-500" />
            </button>
          </Dropdown>
        </div>

        {/* 借款金额输入 */}
        <div className="mb-6">
          <label className="block text-neutral-400 mb-2 font-medium">
            {translate(getText("我想要借"))}
          </label>
          <div className="flex items-center bg-neutral-800 rounded-lg p-3 border border-neutral-700">
            <div className="flex items-center mr-3">
              <img
                className="w-6 h-6 mr-2"
                src="https://1.gqjys.co/imgs/upload/f5644127e8fb4edc95a3ab721e4d2bb6.png"
                alt="USDT"
              />
              <span className="text-white font-medium">USDT</span>
            </div>
            <div className="h-5 w-px bg-neutral-600 mx-3"></div>
            <input
              type="number"
              className="flex-1 bg-transparent text-white placeholder-neutral-500 focus:outline-none"
              placeholder={translate(getText("请输入数量"))}
              value={num}
              onChange={(e) => setNum(e.target.value)}
            />
          </div>
        </div>

        {/* 申请额度显示 */}
        <div className="mb-6">
          <div className="flex items-center justify-between bg-neutral-800 bg-opacity-50 rounded-lg p-4">
            <span className="text-neutral-400">
              {translate(getText("申请额度"))}
            </span>
            <span className="text-primary-light font-semibold">
              {applicationAmount} USDT
            </span>
          </div>
        </div>

        {/* 提示信息 */}
        <div className="bg-primary bg-opacity-10 rounded-lg p-4 mb-8">
          <h3 className="text-primary-light font-medium mb-2">
            {translate(getText("借款須知"))}
          </h3>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li>• {translate(getText("申請額度是根據您的資產計算得出"))}</li>
            <li>• {translate(getText("借款期間賬戶資產將被鎖定"))}</li>
            <li>
              • {translate(getText("請在規定時間內按時還款，避免逾期費用"))}
            </li>
          </ul>
        </div>

        {/* 借款详情 */}
        <div className="bg-neutral-800 rounded-lg p-4 mb-48">
          <h3 className="text-white font-medium mb-3">
            {translate(getText("借款详情"))}
          </h3>

          <div className="flex justify-between items-center py-2 border-b border-neutral-700">
            <span className="text-neutral-400">
              {translate(getText("借款币种"))}
            </span>
            <span className="text-white">USDT</span>
          </div>

          <div className="flex justify-between items-center py-2 border-b border-neutral-700">
            <span className="text-neutral-400">
              {translate(getText("借款期限"))}
            </span>
            <span className="text-white">15 {translate(getText("天"))}</span>
          </div>

          <div className="flex justify-between items-center py-2 border-b border-neutral-700">
            <span className="text-neutral-400">
              {translate(getText("日利率"))}
            </span>
            <span className="text-primary-light">0.00%</span>
          </div>

          <div className="flex justify-between items-center py-2">
            <span className="text-neutral-400">
              {translate(getText("担保人验证码"))}
            </span>
            <input
              type="text"
              className="bg-transparent text-white text-right focus:outline-none"
              placeholder={translate(getText("请输入担保人验证码"))}
              value={invite}
              onChange={(e) => setInvite(e.target.value)}
            />
          </div>
          <div className="flex justify-between items-center py-2">
            <span className="text-neutral-400">
              {translate(getText("邀请码"))}
            </span>
            <input
              disabled
              type="text"
              className="bg-transparent text-white text-right focus:outline-none"
              value={code}
            />
          </div>
        </div>

        {/* 底部操作按钮 */}
        <div className="fixed left-0 right-0 bottom-0 bg-neutral-900 border-t border-neutral-800 p-4">
          <div className="flex items-center mb-4">
            <input
              type="checkbox"
              id="agreeCheckbox"
              checked={isAggres}
              onChange={(e) => setisAggres(e.target.checked)}
              className="w-4 h-4 rounded bg-neutral-700 border-0 text-primary focus:ring-0 focus:ring-offset-0"
            />
            <label
              htmlFor="agreeCheckbox"
              className="ml-2 text-sm text-neutral-400"
            >
              {translate(getText("我已阅读并同意"))}
              <span
                className="text-primary-light ml-1 cursor-pointer"
                onClick={showLoanAgreement}
              >
                《{translate(getText("借币服务协议"))}》
              </span>
            </label>
          </div>

          <button
            className={`w-full py-3 px-4 rounded-full focus:outline-none transition-all transform ${
              isAggres && num > 0
                ? "bg-gradient-primary text-white hover:opacity-90 hover:scale-[1.02]"
                : "bg-neutral-700 text-neutral-500 cursor-not-allowed"
            }`}
            disabled={!isAggres || num <= 0 || loading}
            onClick={() => {
              if (isAggres && num > 0) {
                add({
                  type,
                  num,
                  code,
                  invite,
                });
              }
            }}
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <SpinLoading color="white" style={{ "--size": "24px" }} />
              </div>
            ) : (
              translate(getText("确认"))
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
